import React, { Component } from 'react'
import { SimpleModal } from 'app/elements/Modal'

// Assets
import IcClose from 'app/elements/Icon/ic-close'
import { darkBlue } from 'styles/settings/colors'

// Styles
import {
  Header,
  Back,
  WrapperContentModal,
  WrapperButton,
  Button,
  Input,
  Paragraph
} from './styles'
// Components

class CreateEditFilterSelectionModal extends Component {
  state = {
    loading: false,
    inputValue: ''
  }

  componentDidMount() {
    if (this.props.editFilter) {
      this.setState({
        inputValue: this.props.editFilter.descricaoFiltro
      })
    }
  }

  onChangeInput = e => {
    this.setState({
      inputValue: e.target.value
    })
  }

  chooseOnSubmit = async () => {
    const { onCreate, onEdit, onDelete, toggleModal, modalType, editFilter } = this.props
    const { inputValue } = this.state

    this.setState({ loading: true })
    if (modalType === 'EDIT') {
      await onEdit(inputValue)
    } else if (modalType === 'CREATE') {
      await onCreate(inputValue)
    } else {
      await onDelete(editFilter.id)
    }
    this.setState({ loading: false })

    toggleModal()
  }

  handleCloseModal = () => {
    this.props.toggleModal()
  }

  handleCloseModalSuccess = () => {
    this.handleCloseModal()
  }

  renderContentModal = () => {
    const { editFilter, modalType } = this.props
    const { loading } = this.state
    if (editFilter && modalType === 'EDIT') {
      return (
        <WrapperContentModal>
          <div>
            <Header>Salvar alterações</Header>
          </div>
          <Input
            onChange={this.onChangeInput}
            value={this.state.inputValue}
            type="text"
            placeholder="Insira o nome da seleção"
          />
          <WrapperButton>
            <Button type="button" secondary disabled={loading} onClick={this.handleCloseModal}>
              Cancelar
            </Button>
            <Button
              type="button"
              disabled={!this.state.inputValue || loading}
              onClick={this.chooseOnSubmit}
            >
              {loading ? 'Salvando' : 'Salvar'}
            </Button>
          </WrapperButton>
        </WrapperContentModal>
      )
    }
    if (editFilter && modalType === 'DELETE') {
      return (
        <WrapperContentModal>
          <div>
            <Header>Excluir seleção</Header>
          </div>
          <Paragraph>
            Tem certeza que deseja excluir a seleção <b>{editFilter.descricaoFiltro}</b>
          </Paragraph>
          <WrapperButton>
            <Button type="button" disabled={loading} secondary onClick={this.handleCloseModal}>
              Cancelar
            </Button>
            <Button type="button" disabled={loading} onClick={this.chooseOnSubmit}>
              {loading ? 'Excluindo' : 'Excluir'}
            </Button>
          </WrapperButton>
        </WrapperContentModal>
      )
    }
    return (
      <WrapperContentModal>
        <div>
          <Header>Nova seleção</Header>
        </div>
        <Input
          onChange={this.onChangeInput}
          value={this.state.inputValue}
          type="text"
          placeholder="Insira o nome da seleção"
        />
        <WrapperButton>
          <Button type="button" secondary disabled={loading} onClick={this.handleCloseModal}>
            Cancelar
          </Button>
          <Button
            type="button"
            disabled={!this.state.inputValue || loading}
            onClick={this.chooseOnSubmit}
          >
            {loading ? 'Salvando' : 'Salvar'}
          </Button>
        </WrapperButton>
      </WrapperContentModal>
    )
  }

  render() {
    const { isOpen, toggleModal } = this.props
    const iconColor = darkBlue
    if (isOpen) {
      return (
        <SimpleModal maxWidth={615} minHeight="0" borderRadius={8} hideModal={toggleModal}>
          {this.renderContentModal()}
          <Back onClick={this.handleCloseModal}>
            <IcClose width={24} height={24} fill={iconColor} />
          </Back>
        </SimpleModal>
      )
    }
    return null
  }
}

export default CreateEditFilterSelectionModal



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatement/FilterByIdentifier/CreateEditFilterSelectionModal/index.js